import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { onUnauthorized } from './util/clients/sessionExpiry';

// Must happen here, before the router is installed -- app.use(router) kicks
// off the page's initial navigation (running router/index.js's beforeEach
// guard) before any component (including App.vue) gets created.
// Rehydrating from App.vue's created() instead was too late: the guard
// already saw a logged-out store and bounced to /login even though a valid
// JWT was sitting right there in localStorage the whole time -- most visible
// on a fresh tab or a hard refresh of a deep link.
store.commit('auth/token/rehydrateLogin');

// Expired session (or access removed): back to the login screen, returning to
// this page afterwards, instead of every screen just failing to load.
onUnauthorized(() => {
  store.commit('auth/token/setLoggedOut');
  store.commit('auth/token/setLoginError', 'Your session has ended. Please log in again.');
  const { currentRoute } = router;
  if (currentRoute.value.name !== 'Login') {
    router.push({ name: 'Login', query: { redirect: currentRoute.value.fullPath } });
  }
});

createApp(App)
  .use(store)
  .use(router)
  .use(vuetify)
  .mount('#app');
